var ChannelTabs;

ChannelTabs = window.ChannelTabs != null ? window.ChannelTabs : window.ChannelTabs = {};

ChannelTabs.init = function(arg, done) {
  var categoriesBaseUrl;
  categoriesBaseUrl = arg.categoriesBaseUrl;
  return $(function() {
    $(".primary-nav").find("a[href='" + categoriesBaseUrl + "']").parent().addClass('active');
    return done();
  });
};

module.exports = ChannelTabs;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2NoYW5uZWxfdGFicy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2RlYWwvZnJvbnRlbmQvY2hhbm5lbF90YWJzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLFdBQUEsZ0NBQWMsTUFBTSxDQUFDLGNBQVAsTUFBTSxDQUFDLGNBQWU7O0FBRXBDLFdBQVcsQ0FBQyxJQUFaLEdBQW1CLFNBQUMsR0FBRCxFQUFzQixJQUF0QjtBQUNqQixNQUFBO0VBRG1CLG9CQUFEO1NBQ2xCLENBQUEsQ0FBRSxTQUFBO0lBQ0EsQ0FBQSxDQUFFLGNBQUYsQ0FBaUIsQ0FBQyxJQUFsQixDQUF1QixVQUFBLEdBQVcsaUJBQVgsR0FBNkIsSUFBcEQsQ0FBd0QsQ0FBQyxNQUF6RCxDQUFBLENBQWlFLENBQUMsUUFBbEUsQ0FBMkUsUUFBM0U7V0FDQSxJQUFBLENBQUE7RUFGQSxDQUFGO0FBRGlCOztBQU1uQixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
